// extracted by mini-css-extract-plugin
export var bounce = "_if-1";
export var generatingText = "_if-6";
export var lightning = "_if-4";
export var popup = "_if-5";
export var progressBar = "_if-7";
export var progressFill = "_if-8";
export var progressShimmer = "_if-9";
export var progressText = "_if-a";
export var shimmer = "_if-3";
export var uploadIcon = "_if-0";
export var uploadingText = "_if-2";